import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { WithChildren } from 'ts-types';

export const SkeletonWrapper: FC<
  { isShow: boolean; height: number; width?: number | string; borderRadius?: number } & WithChildren
> = ({ isShow, height, children, width, borderRadius }) => {
  if (isShow) return <Skeleton height={height} width={width} borderRadius={borderRadius} />;
  return <>{children}</>;
};
